module.exports = __webpack_public_path__ + "img/full-screen.4856e795.png";